/** Admin guide §5 — Address Book (`admin/AddressBookTab.tsx`, Settings → Address Book). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, Callout, HelpSectionCard, Li, P, Shot } from '../HelpPrimitives.js';

export function AdminAddressBook(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('admin-address-book')}>
      <Shot
        slug="admin-address-book"
        caption="The Address Book: staff contacts with their category and email."
      />
      <P>
        A directory of staff contacts used elsewhere in the app (for example when picking a sourcer
        or a notification recipient). Click <Btn>Add</Btn> to create an entry, the pencil icon to
        edit one.
      </P>
      <Bullets>
        <Li>
          <Btn>Name</Btn> and <Btn>Email</Btn> are required.
        </Li>
        <Li>
          <Btn>Category</Btn> — Sourcer, Recruiter, Manager, Notification Recipient, or Other;
          defaults to Sourcer on a new entry.
        </Li>
      </Bullets>
      <Callout title="Deleting an entry is immediate">
        <P>The trash icon removes it right away — there is no confirmation step.</P>
      </Callout>
    </HelpSectionCard>
  );
}
